import React__default from 'react';
import { C as ChannelListProvider } from './ChannelListProvider-7c351968.js';
import ChannelListUI from './ChannelList/components/ChannelListUI.js';
import './tslib.es6-83aa13f5.js';
import './topics-17d99dd6.js';
import './uuid-6d14d007.js';
import './utils-9ef11656.js';
import './UserProfileContext-daa99f9b.js';
import 'prop-types';
import './useSendbirdStateContext.js';
import './withSendBird.js';
import './_rollupPluginBabelHelpers-8e4fae98.js';
import './index-ad4c9e58.js';
import './ChannelList/components/ChannelListHeader.js';
import './LocalizationContext-b021af8f.js';
import './stringSet-91746bf1.js';
import './index-353f13f3.js';
import './index-a611bd38.js';
import './ui/IconButton.js';
import './ui/Avatar.js';
import './ui/ImageRenderer.js';
import './ui/Icon.js';
import './ChannelList/components/AddChannel.js';
import './CreateChannel.js';
import './CreateChannel/components/CreateChannelUI.js';
import './CreateChannelProvider-ddfd92e6.js';
import './sendBirdSelectors.js';
import './CreateChannel/components/InviteMembers.js';
import './ui/Modal.js';
import 'react-dom';
import './index-1fd114b0.js';
import './index-41a6f4f2.js';
import './ui/UserListItem.js';
import './ui/MutedAvatarOverlay.js';
import './ui/Checkbox.js';
import './ui/UserProfile.js';
import './ui/ContextMenu.js';
import './ui/SortByRow.js';
import './CreateChannel/components/SelectChannelType.js';
import './ChannelList/components/ChannelPreview.js';
import './ui/ChannelAvatar.js';
import './utils-7d39b941.js';
import './ui/Badge.js';
import './index-86b0a341.js';
import './index-f119413c.js';
import './index-4a59a866.js';
import './ui/MentionUserLabel.js';
import './ChannelList/components/ChannelPreviewAction.js';
import './EditUserProfile.js';
import './index-358226c7.js';
import './ui/Input.js';
import './ui/TextButton.js';
import './color-2863fbbe.js';
import './actionTypes-189daf51.js';
import './index-303a3b6e.js';
import './ui/Loader.js';

var ChannelList = function ChannelList(props) {
  return /*#__PURE__*/React__default.createElement(ChannelListProvider, {
    className: props === null || props === void 0 ? void 0 : props.className,
    disableUserProfile: props === null || props === void 0 ? void 0 : props.disableUserProfile,
    allowProfileEdit: props === null || props === void 0 ? void 0 : props.allowProfileEdit,
    onBeforeCreateChannel: props === null || props === void 0 ? void 0 : props.onBeforeCreateChannel,
    onThemeChange: props === null || props === void 0 ? void 0 : props.onThemeChange,
    onProfileEditSuccess: props === null || props === void 0 ? void 0 : props.onProfileEditSuccess,
    onChannelSelect: props === null || props === void 0 ? void 0 : props.onChannelSelect,
    sortChannelList: props === null || props === void 0 ? void 0 : props.sortChannelList,
    queries: props === null || props === void 0 ? void 0 : props.queries,
    disableAutoSelect: props === null || props === void 0 ? void 0 : props.disableAutoSelect
  }, /*#__PURE__*/React__default.createElement(ChannelListUI, {
    renderChannelPreview: props === null || props === void 0 ? void 0 : props.renderChannelPreview,
    renderUserProfile: props === null || props === void 0 ? void 0 : props.renderUserProfile,
    renderHeader: props === null || props === void 0 ? void 0 : props.renderHeader,
    renderPlaceHolderEmptyList: props === null || props === void 0 ? void 0 : props.renderPlaceHolderEmptyList,
    renderPlaceHolderError: props === null || props === void 0 ? void 0 : props.renderPlaceHolderError,
    renderPlaceHolderLoading: props === null || props === void 0 ? void 0 : props.renderPlaceHolderLoading
  }));
};

export { ChannelList as default };